import {ResponsiveLine} from '@nivo/line'

import {USD_DISPLAY_DECIMALS} from '@/constants/config'
import {useCurrencySymbol} from '@/lib/locale/country'
import {Theme} from '@/lib/theme/theme'
import {useCurrentTheme} from '@/lib/theme/useCurrentTheme'
import {formatLocaleDateTime} from '@/utils/datetime'

import type {Data} from './PriceHistory'
import style from './PriceHistory.module.scss'

export default memo<{data: Data[]}>(function PriceChart({data}) {
  const currencySymbol = useCurrencySymbol()
  const [theme] = useCurrentTheme()

  if (data.length === 0) return null

  return (
    <ResponsiveLine
      data={data}
      margin={{top: 30, right: 40, bottom: 60, left: 60}}
      xScale={{type: 'time'}}
      // xFormat={(value) =>
      //   formatLocaleDateTime(value, 'en-US', {
      //     year: 'numeric',
      //     month: 'numeric',
      //   })
      // }
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false,
      }}
      yFormat={value => currencySymbol + Number(value).toFixed(USD_DISPLAY_DECIMALS)}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        format: value =>
          formatLocaleDateTime(value as Date, 'en-US', {
            year: 'numeric',
            month: 'short',
          }),
        tickValues: data[0]?.data.map(data => data.x),
        tickSize: 0,
        tickPadding: 16,
        tickRotation: 45,
        truncateTickAt: 0,
      }}
      axisLeft={{
        format: (value: number) => currencySymbol + Number(value).toFixed(USD_DISPLAY_DECIMALS),
        tickSize: 0,
        tickPadding: 12,
        tickRotation: 0,
        truncateTickAt: 0,
      }}
      lineWidth={3}
      pointSize={10}
      pointColor={{from: 'color'}}
      pointBorderWidth={2}
      pointBorderColor={{from: 'seriesColor'}}
      pointLabelYOffset={-12}
      // enablePointLabel
      enableTouchCrosshair
      useMesh
      legends={[
        {
          anchor: 'top',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: -30,
          itemsSpacing: 0,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          // effects: [
          //   {
          //     on: 'hover',
          //     style: {
          //       itemBackground: 'rgba(0, 0, 0, .03)',
          //       itemOpacity: 1,
          //     },
          //   },
          // ],
        },
      ]}
      tooltip={data => {
        return (
          <div className={style.Tooltip}>
            <div
              className={style.LegendColor}
              style={{
                backgroundColor: data.point.seriesColor,
              }}
            />
            {data.point.seriesId}: <span className={style.Value}>{data.point.data.yFormatted}</span>
          </div>
        )
      }}
      theme={{
        grid: {
          line: {
            stroke: theme === Theme.Dark ? '#ffffff3F' : '#0000003F',
            strokeWidth: 1,
            strokeDasharray: '4 4',
          },
        },
        crosshair: {
          line: {
            stroke: theme === Theme.Dark ? '#ffffff' : '#000000',
          },
        },
        legends: {
          text: {
            textTransform: 'capitalize',
          },
        },
        text: {
          fill: theme === Theme.Dark ? '#fff' : '#000',
          fontFamily: 'Manrope',
          fontSize: '0.75rem',
          fontWeight: 400,
        },
      }}
    />
  )
})
